var map = {
	"./MPR_single BW CS5": 22,
	"./MPR_single BW CS5 copy": 23,
	"./MPR_single BW CS5 copy.svg": 23,
	"./MPR_single BW CS5.svg": 22,
	"./interactive-map": 24,
	"./interactive-map.jpg": 24,
	"./mprarchive": 25,
	"./mprarchive-white": 26,
	"./mprarchive-white.svg": 26,
	"./mprarchive.svg": 25,
	"./mprnews-archive-bg-widescreen": 27,
	"./mprnews-archive-bg-widescreen.jpg": 27,
	"./mprnews-archive-light-bg-widescreen": 28,
	"./mprnews-archive-light-bg-widescreen.jpg": 28,
	"./national-archives_logo": 29,
	"./national-archives_logo.png": 29,
	"./section-bg-photo": 30,
	"./section-bg-photo-2": 31,
	"./section-bg-photo-2.jpg": 31,
	"./section-bg-photo.jpg": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;